import { DictionaryService } from './dictionary/dictionary.service';
import { RolesService } from './roles/roles-service.service';
import { SnackbarMessageService } from './snackbar-message/snackbar-message.service';

const service = {
  SnackbarMessageService,
  RolesService,
  DictionaryService
};

export default service;
